import { FView } from './FView'

export function FPage() {
  return <FView />
}
